// @flow
import * as React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Indicator from 'app/components/Subs/Indicator';
import LinkButton from 'app/components/Tariff/LinkButton';
import PriceDiscounted, { priceTypes } from 'app/components/Tariff/PriceDiscounted';

import type { Sub, MonthDailyParams, MonthDailyPeriod } from '../../Tariff';
import enhanceMonthDailyPeriods from './enhanceMonthDailyPeriods';
import styles from './MonthDailyPeriods.scss';


type Props = {
  subId?: number | string,
  sub?: Sub,
  params?: MonthDailyParams,
  periods: Array<MonthDailyPeriod>,
  handleToggle: (e: SyntheticEvent<HTMLElement>) => void,
  isOpen: boolean,
  footnotes: Object,
  locked?: boolean,
  studentId: number,
  tariffId?: number,
  tariffBundleId?: number,
};

const MonthDailyPeriods = ({
  subId,
  params, // eslint-disable-line no-unused-vars
  periods,
  handleToggle,
  isOpen,
  footnotes,
  locked,
  studentId,
  tariffId,
  tariffBundleId,
}: Props) => {
  const { t } = useTranslation('tariff');

  return (
    <div className={classNames((isOpen || !subId) && styles.root)}>
      {subId && !isOpen && <div className={styles.content}>
        <Indicator subId={subId} footnotes={footnotes} showCircle />
      </div>}
      {(isOpen || !subId)
        && <div className={styles.content}>
          <div className={styles.title}>
            {`${t('available_subscriptions')}:`}
            {footnotes.monthDailyPause
              && <sup className={styles.fn}>{footnotes.monthDailyPause.index}</sup>}
          </div>
          {periods.map(({ title, months_number: num/* , cost */ }) =>
            <div key={title} className={styles.row}>
              <span className={styles.rowTitle}>{title}</span>
              {/* <span className={styles.rowCost}>{cost}</span> */}
              <PriceDiscounted
                className={styles.rowCost}
                studentId={studentId}
                tariffId={tariffId}
                tariffBundleId={tariffBundleId}
                priceType={priceTypes.price_base_on_months}
                monthsNumber={num}
              />
            </div>)}
        </div>}
      {subId
        && !locked
        && <div className={classNames(styles.content, styles.buttons)}>
          {/* // $FlowFixMe */}
          <LinkButton
            primary={!isOpen}
            onClick={handleToggle}
            name="showPacks"
          >
            {isOpen ? t('back_link') : t('available_subscriptions_link')}
          </LinkButton>
        </div>}
    </div>
  );
};

export default enhanceMonthDailyPeriods(MonthDailyPeriods);
